export const locale = {
  lang: "ru",
  data: {
    SEARCH_BAR: {
      PLACEHOLDER: "Поиск",
    },
    TOOLBAR_RIGHT: {
      ONLINE: "На линии",
      PROFILE: "Профиль",
      MAIL: "Почта",
      LOGOUT: "Выход",
      EXEC: "Выполнить",
    },
    COMMANDS: {
      EXEC: "Выполнить",
      EXEC_QUESTION: "Вы действительно хотите выполнить команду?",
      CANCEL: "Отмена",
      EXEC_COMMAND: "Выполнение команды",
      EXEC_SUCCESS: "Команда успешно выполнена",
      EXEC_ERROR: "Ошибка выполнения команды",
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/main/toolbar/i18n/ru.ts